export enum PlatformApplyWithProfileKind {
  BOARD = 'board',
  SAVED = 'saved',
  INVITATION = 'invitation',
  JOBBOARD = 'jobboard',
  FOLLOW_UP = 'follow-up',
}
